import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { media } from '../../../components/Layout/breakpoints';

export const StyledImage = styled(GatsbyImage)`
  height: auto;
  width: 100%;
  max-height: 628px;
  aspect-ratio: 628/502;

  ${media.sm`
    width: 100%;
    height: auto;
    aspect-ratio: 2158/872;
  `};
`;
